import { Type } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { FilterListSearchComponent, ListLayout, PimTemplateProperties, RenderFilterValueList, SearchField } from "gung-list";
import { Observable } from "rxjs";
import { User } from "../state/auth/types";
import { GungFlow } from "../state/flow/types";

export interface GungBackendFilterListConfigService<T> {
  topFilter?: boolean;
  selectedFilterTop?: boolean;
  paginationList?: boolean;
  itemsPerRow?: number;
  searchAboveFilters?: boolean;
  searchDisabled?: boolean;
  showFilterTitle?: 'minimal' | 'group';
  sourceClass: string;

  getItems(
    skip: number,
    limit: number,
    searchString: string,
    filterSelected: FilterSelected[],
    user: User,
    flow: GungFlow,
    route?: ActivatedRouteSnapshot,
    selectedSort?: PimTemplateProperties
  ): Observable<any>;
  getItemId(item: T): string;
  getBackendFilters(route?: ActivatedRouteSnapshot): Observable<GungBackendConfigBaseFilter<T>[]>;
  getBatchSizes(route?: ActivatedRouteSnapshot): number[] | undefined;
  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<any>[];
  getSearchTerms(item: T): string[];
  getDefaultSearchField(): SearchField<T>;
  getSearchComponent(): Type<FilterListSearchComponent>;
  getSearchTermFields(): string[];
  getSearchFields?(): SearchField<T>[];
  setPreviousLayout?(val: number): void;
  getSearchPlaceholderTranslate?(): string;
  setSelectedLayout?(index: number): void;
  getSelectedLayout?(): Observable<number>;
  getNothingFoundTranslateTag?(): string;
  getBootstrapCols?(route?: ActivatedRouteSnapshot): number[] | undefined;
  getExtraBackendFilterParams(): Observable<{ [s: string]: any }>;
}

export interface GungBackendConfigBaseFilter<T> {
  type: string;
  field: string;
  getName(): string;
  isActiveFromStart(): boolean;
  isPostFilter(): boolean;
  filterShowMoreItemNumber?: number;
  getOptionName(key: string, item?: T): string;
  changeKeyValue?(key: string, item?: T): string;
  sort?(a, b): number;
  typeInDates?: boolean;
}

export abstract class SimpleGungBackendConfigBaseFilter<T> implements GungBackendConfigBaseFilter<T> {
  type:
    | 'SimpleConfigBaseFilter'
    | 'RangeConfigBaseFilter'
    | 'ColorConfigBaseFilter'
    | 'dateRangeFilter'
    | 'IconConfigBaseFilter'
    | string = 'SimpleConfigBaseFilter';
  abstract field: string;
  abstract getName(): string;
  isActiveFromStart = () => false;
  isPostFilter = () => true;
  abstract getOptionName(key: string, item?: T): string;
}

export interface GungBackendRenderFilter {
  type: string;
  name: string;
  valueList: RenderFilterValueList[];
  active: boolean;
  isPostFilter: boolean;
  excludedIds: string[];
  id?: string;
  maxValue?: number;
  minValue?: number;
}

export interface GungBackendFilterItems<T> {
  entities: T[];
  matchingSearchIds: string[];
}

export interface GungBackendFilter {
  id: string;
  sourceClass: string;
  fieldPath: string;
  options: { [optionName: string]: OptionField };
}

export interface OptionField {
  key: string;
  includedIds: string[];
}

export interface FilterSelected {
  filterId: string;
  filterField?: string;
  optionId?: string;
  optionIdRange?: string[];
  backendFilterValues?: string[];
}
